import {
  getTemplate,
  getUiOptions,
  ObjectFieldTemplateProps,
  RJSFSchema,
  StrictRJSFSchema,
} from '@rjsf/utils';

import { Label } from 'design-system/components/Text';

export function HorizontalLayoutObjectFieldTemplate<
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F = any,
>({
  description,
  properties,
  uiSchema,
  idSchema,
  schema,
  registry,
}: /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
ObjectFieldTemplateProps<T, S, F>) {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const uiOptions = getUiOptions(uiSchema);
  const DescriptionFieldTemplate = getTemplate<'DescriptionFieldTemplate'>(
    'DescriptionFieldTemplate',
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    registry,
    uiOptions,
  );

  // only set title if it's explicitly defined in the schema or uiOptions
  const title = schema.title || uiOptions.title;

  return (
    <>
      {title && (
        <Label size='lg' weight='bold'>
          {title}
        </Label>
      )}
      {(uiOptions.description || description) && (
        <DescriptionFieldTemplate
          id={`${idSchema.$id}-description`}
          description={uiOptions.description || description!}
          schema={schema}
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          uiSchema={uiSchema}
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          registry={registry}
        />
      )}
      <div style={{ display: 'flex' }}>
        {properties.map((element) => (
          <div key={element.name} style={{ flex: '1 1 auto', marginRight: '10px' }}>
            {element.content}
          </div>
        ))}
      </div>
    </>
  );
}
